import { inject } from '@angular/core';
import {
  AuthorizationService,
  InitService,
} from '@infodata-group/inf-commons';
import { PresetService } from '../service/preset.service';
import { DeviceDetectorService } from '@monorepo-projects/inf-commons-lib';
import {
  AoSharedDataService,
  MarkerContentGenerator,
  SharedMapSettingsService,
} from '@monorepo-projects/alwayson-shared';
import { environment } from '../../environments/environment';

export const initializerFactory = () => {
  const initService = inject(InitService);
  const companyPresetService = inject(PresetService);
  const authorizationService = inject(AuthorizationService);
  const deviceDetectorService = inject(DeviceDetectorService);
  const dataService = inject(AoSharedDataService);
  const mapService = inject(SharedMapSettingsService);

  /**
   * Subscribe to AuthService
   */
  authorizationService.subscribe((event) => {
    if (event.name === 'logout') {
      dataService.clear();
      companyPresetService.clear();
    }
  });
  /**
   * Subscribe to InitService
   */
  initService.subscribe((event) => {
    if (event.name === 'settings') {
      companyPresetService.init();
      MarkerContentGenerator.mapService = mapService;
      mapService.initSettings();
    }
  });
  /**
   * Start init service
   */
  initService.init(environment.env);
  if (!deviceDetectorService.isDesktopDevice()) {
    window.location.href = environment.mobileUrl;
  }
};
